import 'slick-carousel';

/**
 * Build the markup for the section
 */
function buildSection(sections) {
  const $container = $('#section-external-container');
  const { buttonUrl, sectionTitle, allRecipes, productId } = $container[0].dataset;

  // loop all recipes and get the ones that have the current product's id in their lundbergShopifyProducts array
  const selectedSections = sections.filter((section) => section.lundbergShopifyProducts.find((id) => id === productId));

  if (!selectedSections.length) {
    return;
  }

  // build the slides
  const sectionsMarkup = selectedSections.map((section) => {
    const { claims, img, title, url } = section;
    // build the claims list items
    const claimsMarkup = claims.map((item) => `<li>${item}</li>`).join('');

    return `<div class="section__content" role="img" aria-label="${img.alt}" style="background-image: url('${img.src}');">
            <a href="${url}" class="section__content-inner">
              <ul class="list-claims">${claimsMarkup}</ul>

              <h2 class="section__title">${title}</h2>
            </a>
          </div>`;
  });

  // build the section markup
  const sectionMarkup = `
    <section class="section-external">
      <div class="shell shell--fluid">
        <div class="section__inner">
          <aside class="section__aside">
            <h4 class="section__aside-title">${sectionTitle}</h4>

            <a href="${buttonUrl}" class="btn btn--md">
              <span>${Shopify.theme.locale.products.product.browse_all_recipes}</span>

              <i class="far fa-arrow-right"></i>
            </a>
          </aside>

          <div class="section__content-container">
            ${sectionsMarkup.join('')}
          </div>
        </div>
      </div>
    </section>
  `;

  // append the markup in the container
  $container.html(sectionMarkup);
  // Init the slider
  initRecipesSlider($container);
}

/**
 * Inits the slider for the recipe items
 * @param  {obj} $container the container object for the slides
 * @return {void}
 */
function initRecipesSlider($container) {
  $container.find('.section__content-container').slick({
    prevArrow: '<i class="js-recipe-prev far fa-chevron-left"></i>',
    nextArrow: '<i class="js-recipe-next far fa-chevron-right"></i>',
    infinite: false,
    loop: false,
  });
}

/**
 * Fetch the recipes array
 * @return {void}
 */
function getSectionsData() {
  const $container = $('#section-external-container');

  if (!$container.length) {
    return;
  }

  const url = $container.data('recipes-endpoint');

  $.ajax({
    url: url,
  })
    .done(function(data) {
      buildSection(data);
    })
    .fail(function() {
      console.log('error');
    });
}

getSectionsData();
